import React from 'react';
import { Form } from '@ant-design/compatible';
import cx from 'classnames';
import ImgUploadInput from '../../ImageUploadInput';

const ImgUploadForm = (props) => {
  const {
    form,
    label,
    rules,
    name,
    initialValue,
    subContent,
    className,
    getValueFromEvent,
    showInfo = true,
    vertical = false,
    ...res
  } = props;
  const { getFieldDecorator } = form;

  return (
    <div className={className}>
      <Form.Item className={cx('input-form', 'amondz-form', { 'with-label': label }, { vertical })} label={label}>
        {getFieldDecorator(name, {
          rules,
          initialValue,
          getValueFromEvent,
        })(<ImgUploadInput {...res} />)}
      </Form.Item>

      {subContent && showInfo ? <div className="amondz-form-sub-content"> {subContent}</div> : null}
    </div>
  );
};

export default ImgUploadForm;
